export function handleButtonsWithSource()
{
  const btnEls = document.querySelectorAll('.js-button-with-source')

  btnEls.forEach(btnEl => btnEl.addEventListener('click', e => {
    e.preventDefault()

    const fancyEl = document.querySelector(btnEl.dataset.src)

    fancyEl.querySelector('input[name="source"]').value = btnEl.dataset.source

    $.fancybox.open({
      src: btnEl.dataset.src
    })
  }))
}
